/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ShapesIcon = ({ width = 24, height = 24, hidden = false, title = 'Shapes' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M22.521 31.8a11.308 11.308 0 0 1-11.052-9.023l-.032-.16H1.734a.256.256 0 0 1-.224-.13.249.249 0 0 1 0-.257l10.226-17.9a.26.26 0 0 1 .45 0l3.941 6.899.18-.12a11.28 11.28 0 1 1 6.214 20.692Zm-9.085-8.933a9.381 9.381 0 1 0 3.789-10.09l-.153.104 5.342 9.35a.249.249 0 0 1 0 .255.256.256 0 0 1-.225.131h-8.818Z"
    />
  </svg>`;
};
